// Vetro product page enhancements: gallery arrows + description read-more
(function () {
  function init() {
    initGalleryArrows();
    initReadMore();
    initLightbox();
    initStickyAtc();
    initWallPreview();
  }

  /* ---------- "Preview on your wall": client-side room mockup tool ---------- */
  function initWallPreview() {
    var gallery = document.querySelector('media-gallery');
    var artImg = document.querySelector('product-modal .product-media-modal__content img') || document.querySelector('.product__media img');
    if (!gallery || !artImg) return;
    var artSrc = artImg.currentSrc || artImg.src;

    var openBtn = document.createElement('button');
    openBtn.type = 'button';
    openBtn.className = 'vetro-preview-open';
    openBtn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="1.5"/><path d="M3 15l4.5-4.5 3.5 3.5 5-5L21 14"/><circle cx="8.5" cy="9" r="1.2"/></svg>' +
      '<span>Preview on your wall</span>';
    var anchor =
      document.querySelector('.vetro-pdp-trust') ||
      document.querySelector('.product-form__buttons') ||
      document.querySelector('.product-form');
    if (anchor) {
      anchor.insertAdjacentElement('afterend', openBtn);
    } else {
      gallery.insertAdjacentElement('afterend', openBtn);
    }

    var ui = null;

    openBtn.addEventListener('click', function () {
      if (!ui) ui = build();
      ui.overlay.classList.add('is-open');
      document.body.classList.add('vetro-lb-open');
    });

    function build() {
      var overlay = document.createElement('div');
      overlay.className = 'vetro-preview';
      overlay.innerHTML =
        '<div class="vetro-preview__bar">' +
        '<span class="vetro-preview__title">Preview on your wall</span>' +
        '<span class="vetro-preview__hint">Drag to move · pull the corner to resize</span>' +
        '<button type="button" class="vetro-lb__close vetro-preview__close" aria-label="Close">✕</button>' +
        '</div>' +
        '<div class="vetro-preview__stage">' +
        '<label class="vetro-preview__drop">' +
        '<input type="file" accept="image/*" hidden>' +
        '<span class="vetro-preview__drop-icon">📷</span>' +
        '<strong>Upload a photo of your kitchen</strong>' +
        '<span>Your photo never leaves your device.</span>' +
        '</label>' +
        '<div class="vetro-preview__scene" hidden>' +
        '<img class="vetro-preview__room" alt="">' +
        '<div class="vetro-preview__panel">' +
        '<span class="vetro-preview__handle" aria-hidden="true"></span>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="vetro-preview__controls" hidden>' +
        '<button type="button" class="button button--secondary vetro-preview__change">Change photo</button>' +
        '<div class="vetro-preview__modes" role="group" aria-label="Edit mode">' +
        '<button type="button" class="vetro-preview__mode is-active" data-mode="panel">Move panel</button>' +
        '<button type="button" class="vetro-preview__mode" data-mode="art">Adjust artwork</button>' +
        '</div>' +
        '<label class="vetro-preview__zoom">Artwork zoom <input type="range" min="100" max="400" value="210"></label>' +
        '<button type="button" class="button vetro-preview__atc">Add to cart</button>' +
        '</div>';
      document.body.appendChild(overlay);

      var stage = overlay.querySelector('.vetro-preview__stage');
      var scene = overlay.querySelector('.vetro-preview__scene');
      var drop = overlay.querySelector('.vetro-preview__drop');
      var fileInput = overlay.querySelector('input[type="file"]');
      var room = overlay.querySelector('.vetro-preview__room');
      var panel = overlay.querySelector('.vetro-preview__panel');
      var controls = overlay.querySelector('.vetro-preview__controls');
      var zoom = overlay.querySelector('.vetro-preview__zoom input');

      panel.style.backgroundImage = 'url("' + artSrc + '")';

      /* artwork state: zoom + position inside the panel */
      var art = { zoom: 210, x: 50, y: 42 };
      var editMode = 'panel';

      function applyArt() {
        panel.style.backgroundSize = art.zoom + '%';
        panel.style.backgroundPosition = art.x + '% ' + art.y + '%';
      }
      applyArt();

      var modeBtns = overlay.querySelectorAll('.vetro-preview__mode');
      modeBtns.forEach(function (mb) {
        mb.addEventListener('click', function () {
          editMode = mb.dataset.mode;
          modeBtns.forEach(function (x) { x.classList.toggle('is-active', x === mb); });
          panel.classList.toggle('is-art-mode', editMode === 'art');
        });
      });

      function close() {
        overlay.classList.remove('is-open');
        document.body.classList.remove('vetro-lb-open');
      }
      overlay.querySelector('.vetro-preview__close').addEventListener('click', close);
      overlay.querySelector('.vetro-preview__change').addEventListener('click', function () {
        fileInput.click();
      });
      overlay.querySelector('.vetro-preview__atc').addEventListener('click', function () {
        close();
        var submit = document.querySelector('.product-form__submit');
        if (submit) submit.click();
      });

      function loadFile(file) {
        if (!file || file.type.indexOf('image/') !== 0) return;
        var reader = new FileReader();
        reader.onload = function (e) {
          room.onload = function () {
            scene.hidden = false;
            drop.hidden = true;
            controls.hidden = false;
            panel.classList.add('is-animating');
            panel.style.left = '28%';
            panel.style.top = '30%';
            panel.style.width = '44%';
            panel.style.height = '28%';
            setTimeout(function () {
              panel.classList.remove('is-animating');
            }, 700);
          };
          room.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      fileInput.addEventListener('change', function () { loadFile(fileInput.files[0]); });
      stage.addEventListener('dragover', function (e) { e.preventDefault(); });
      stage.addEventListener('drop', function (e) {
        e.preventDefault();
        loadFile(e.dataTransfer.files[0]);
      });

      zoom.addEventListener('input', function () {
        art.zoom = parseFloat(zoom.value);
        applyArt();
      });

      /* drag + resize + artwork pan */
      var mode = null, sx = 0, sy = 0, start = null, artStart = null;
      panel.addEventListener('pointerdown', function (e) {
        if (e.target.classList.contains('vetro-preview__handle')) {
          mode = 'resize';
        } else if (editMode === 'art') {
          mode = 'art';
        } else {
          mode = 'drag';
        }
        sx = e.clientX;
        sy = e.clientY;
        var r = panel.getBoundingClientRect();
        var s = scene.getBoundingClientRect();
        start = { l: r.left - s.left, t: r.top - s.top, w: r.width, h: r.height, sw: s.width, sh: s.height };
        artStart = { x: art.x, y: art.y };
        panel.setPointerCapture(e.pointerId);
        e.preventDefault();
      });
      panel.addEventListener('pointermove', function (e) {
        if (!mode) return;
        var dx = e.clientX - sx;
        var dy = e.clientY - sy;
        if (mode === 'drag') {
          var l = Math.min(Math.max(start.l + dx, 0), start.sw - start.w);
          var t = Math.min(Math.max(start.t + dy, 0), start.sh - start.h);
          panel.style.left = (l / start.sw) * 100 + '%';
          panel.style.top = (t / start.sh) * 100 + '%';
        } else if (mode === 'resize') {
          var w = Math.min(Math.max(start.w + dx, 60), start.sw - start.l);
          var h = Math.min(Math.max(start.h + dy, 40), start.sh - start.t);
          panel.style.width = (w / start.sw) * 100 + '%';
          panel.style.height = (h / start.sh) * 100 + '%';
        } else {
          // pan the artwork inside the panel; travel scales with zoom overflow
          var span = art.zoom - 100;
          if (span <= 0) return;
          art.x = Math.min(100, Math.max(0, artStart.x - (dx / start.w) * 100 * (100 / span)));
          art.y = Math.min(100, Math.max(0, artStart.y - (dy / start.h) * 100 * (100 / span)));
          applyArt();
        }
      });
      ['pointerup', 'pointercancel'].forEach(function (t) {
        panel.addEventListener(t, function () { mode = null; });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
      });

      return { overlay: overlay };
    }
  }

  /* ---------- Mobile sticky add-to-cart bar ---------- */
  function initStickyAtc() {
    var form = document.querySelector('.product-form form');
    var submit = document.querySelector('.product-form__submit');
    var titleEl = document.querySelector('.product__title h1');
    var priceEl = document.querySelector('.product .price__regular .price-item');
    if (!form || !submit || !titleEl) return;

    var bar = document.createElement('div');
    bar.className = 'vetro-sticky-atc';
    bar.innerHTML =
      '<div class="vetro-sticky-atc__info">' +
      '<span class="vetro-sticky-atc__title"></span>' +
      '<span class="vetro-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="button vetro-sticky-atc__btn">Add to cart</button>';
    document.body.appendChild(bar);

    var t = titleEl.textContent.trim();
    bar.querySelector('.vetro-sticky-atc__title').textContent = t.length > 42 ? t.slice(0, 42) + '…' : t;

    function syncPrice() {
      var p = document.querySelector('.product .price__regular .price-item');
      if (p) bar.querySelector('.vetro-sticky-atc__price').textContent = p.textContent.trim();
    }
    syncPrice();
    new MutationObserver(syncPrice).observe(document.querySelector('.product__info-container') || document.body, {
      subtree: true,
      childList: true,
      characterData: true,
    });

    bar.querySelector('.vetro-sticky-atc__btn').addEventListener('click', function () {
      submit.click();
    });

    var threshold = 0;
    function measure() {
      var r = submit.getBoundingClientRect();
      threshold = r.bottom + window.scrollY;
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener(
      'scroll',
      function () {
        var show = window.innerWidth < 990 && window.scrollY > threshold;
        bar.classList.toggle('is-visible', show);
      },
      { passive: true }
    );
  }

  /* ---------- Fullscreen lightbox: single image, arrows, swipe ---------- */
  function initLightbox() {
    var mediaList = document.querySelector('ul.product__media-list');
    if (!mediaList) return;

    // hi-res sources: prefer Dawn's (now unused) modal images
    var modalImgs = document.querySelectorAll('product-modal .product-media-modal__content img');
    var listImgs = mediaList.querySelectorAll('.product__media img');
    var sources = [];
    var pool = modalImgs.length ? modalImgs : listImgs;
    for (var i = 0; i < pool.length; i++) {
      sources.push(pool[i].currentSrc || pool[i].src);
    }
    if (!sources.length) return;

    var lb, img, counter, index = 0;

    function build() {
      lb = document.createElement('div');
      lb.className = 'vetro-lb';
      lb.innerHTML =
        '<button type="button" class="vetro-lb__close" aria-label="Close">✕</button>' +
        '<button type="button" class="vetro-gallery-nav vetro-gallery-nav--prev" aria-label="Previous image">‹</button>' +
        '<img class="vetro-lb__img" alt="">' +
        '<button type="button" class="vetro-gallery-nav vetro-gallery-nav--next" aria-label="Next image">›</button>' +
        '<div class="vetro-lb__counter"></div>';
      document.body.appendChild(lb);
      img = lb.querySelector('.vetro-lb__img');
      counter = lb.querySelector('.vetro-lb__counter');

      lb.querySelector('.vetro-lb__close').addEventListener('click', close);
      lb.querySelector('.vetro-gallery-nav--prev').addEventListener('click', function () { show(index - 1); });
      lb.querySelector('.vetro-gallery-nav--next').addEventListener('click', function () { show(index + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });

      var startX = null;
      lb.addEventListener('pointerdown', function (e) { startX = e.clientX; });
      lb.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
        startX = null;
      });

      document.addEventListener('keydown', onKey);
    }

    function onKey(e) {
      if (!lb || !lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') show(index + 1);
      if (e.key === 'ArrowLeft') show(index - 1);
    }

    function show(i) {
      index = (i + sources.length) % sources.length;
      img.src = sources[index];
      counter.textContent = (index + 1) + ' / ' + sources.length;
    }

    function open(i) {
      if (!lb) build();
      lb.classList.add('is-open');
      document.body.classList.add('vetro-lb-open');
      show(i);
    }

    function close() {
      lb.classList.remove('is-open');
      document.body.classList.remove('vetro-lb-open');
    }

    // hijack clicks on the main media (Dawn's stacked modal never opens)
    mediaList.addEventListener(
      'click',
      function (e) {
        var media = e.target.closest('.product__media-item');
        if (!media) return;
        e.preventDefault();
        e.stopPropagation();
        var thumbs = document.querySelectorAll('.thumbnail-list .thumbnail');
        var i = 0;
        for (var t = 0; t < thumbs.length; t++) {
          if (thumbs[t].getAttribute('aria-current') === 'true') { i = t; break; }
        }
        open(i);
      },
      true
    );
  }

  function initGalleryArrows() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var thumbs = Array.prototype.slice.call(
      document.querySelectorAll('.thumbnail-list .thumbnail')
    );
    if (thumbs.length < 2) return;

    var viewer = gallery.querySelector('ul.product__media-list');
    var host = viewer ? viewer.parentElement : gallery;
    host.classList.add('vetro-gallery-host');

    function currentIndex() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    function go(delta) {
      var next = (currentIndex() + delta + thumbs.length) % thumbs.length;
      thumbs[next].click();
    }

    var prev = makeArrow('vetro-gallery-nav vetro-gallery-nav--prev', '‹', 'Previous image');
    var next = makeArrow('vetro-gallery-nav vetro-gallery-nav--next', '›', 'Next image');
    prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    host.appendChild(prev);
    host.appendChild(next);
  }

  function makeArrow(cls, label, aria) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('aria-label', aria);
    b.innerHTML = label;
    return b;
  }

  function initReadMore() {
    var desc = document.querySelector('.product__description');
    if (!desc) return;
    var LIMIT = 200; // px
    if (desc.scrollHeight <= LIMIT + 60) return;

    desc.classList.add('vetro-desc-collapsed');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vetro-readmore';
    btn.textContent = 'Read more +';
    btn.addEventListener('click', function () {
      var collapsed = desc.classList.toggle('vetro-desc-collapsed');
      btn.textContent = collapsed ? 'Read more +' : 'Read less −';
      if (collapsed) desc.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
    desc.insertAdjacentElement('afterend', btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
